import { Injectable } from '@angular/core';

import { TradeExecutionMode } from '../_model/house-trade';

export type OrderPrefill = {
  haveCurrency: string;
  haveAmount: number;
  needCurrency: string;
  needAmount: number;
  price: number;
  executionMode?: TradeExecutionMode;
};

@Injectable({ providedIn: 'root' })
export class OrderDraftService {
  private key = 'order_prefill';

  set(draft: OrderPrefill) {
    sessionStorage.setItem(this.key, JSON.stringify(draft));
  }

  get(): OrderPrefill | null {
    const raw = sessionStorage.getItem(this.key);
    return raw ? (JSON.parse(raw) as OrderPrefill) : null;
  }

  pop(): OrderPrefill | null {
    const d = this.get();
    sessionStorage.removeItem(this.key);
    return d;
  }
}
